import { render, staticRenderFns } from "./ProductLocalCustomerCreateForm.vue?vue&type=template&id=1ff3e77e&"
import script from "./ProductLocalCustomerCreateForm.vue?vue&type=script&lang=js&"
export * from "./ProductLocalCustomerCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports